import { combineReducers } from 'redux';
import { reducer as paymentProcessingPanelReducer } from './PaymentTerminalsPanel/redux/slice';

export const paymentProcessingTabReducer = combineReducers({
  paymentTerminalsPanel: paymentProcessingPanelReducer,
});
